import { KYMW0906Component } from './kymw0906.component';

/**
 * 予約商品設定画面の値を管理するクラス
 *
 * @export KYMW0906Model
 * @class KYMW0906Model
 */
export class KYMW0906Model {

  kymw0906Component: KYMW0906Component;

  // 編集有無フラグ
  public isEdited = false;

  // モード
  public mode: number = null;

  // 登録済みの配達企画回・アイテムコードの組み合わせリスト
  public registeredDeliveryCatalogAndItemCodeList = [];

  // 束ね企画回の終了企画回
  public bundleEndDeliveryOrder = '';

  // 配達企画回
  public deliveryCatalog = '';

  // 変更前配達企画回
  public beforeChangeDelivCatalog = '';

  // 配達企画回の終了受注コード
  public deliveryOrderCode = '';

  // 注文コード割当
  public preOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public preOrderOrderNumQuotaCodeList = [];

  // アイテムコード
  public selectedItemCode = '';

  // 選択変更前アイテムコード
  public beforeChangeItemCode = '';

  // アイテムコードリスト
  public itemCodeList = [];

  // アイテムコードに紐付く会員生協リスト
  public enableCoopByItemCodeList = [];

  // 注文コード
  public orderNum = '';

  // 配達企画曜日:月
  public delivMonday = false;

  // 配達企画曜日:火
  public delivTuesday = false;

  // 配達企画曜日:水
  public delivWednesday = false;

  // 配達企画曜日:木
  public delivThursday = false;

  // 配達企画曜日:金
  public delivFriday = false;

  // 専用商品名
  public preOrderGoodsName = '';

  // 専用商品名(カナ)
  public preOrderGoodsNameKana = '';

  // 専用規格名
  public preOrderStandardName = '';

  // 専用規格名(カナ)
  public preOrderStandardNameKana = '';

  // セット企画
  public setPreOrderType = false;

  // 値引前供給単価
  public supplyPriceStandard = '';

  // 値引区分
  public discountType = '0';

  // 値引区分リスト
  public discountTypeList = [
    {Code: '0', Name: '値引きなし'},
    {Code: '1', Name: '単価指定'},
    {Code: '2', Name: '率指定'},
  ];

  // 値引単価
  public discountUnitPrice = '';

  // 値引率
  public discountRate = '';

  // 値引後供給単価
  public discountSupplyUnitPrice = '';

  // ポイント数
  public preOrderPoints = '';
  
  // 価格パターン
  public pricePattern = '0';

  // 価格パターンに対応する供給単価リスト
  public supplyPriceList = [];

  // 商品計画数予測リスト
  public goodsPlanNumList = [];

  // 商品計画数予測リスト 全選択
  public goodsPlanNumListEnableFlgAll = false;

  // アイテムコードに紐づく会員生協の一覧
  public itemRelatedCoop = [];

  // 会員タブのアイテムコードに紐づく会員生協の一覧
  public itemRelatedCoop_CoopTab = [];

  // 配達企画回、アイテムコードに紐づく会員生協
  public catalogAndItemRelatedCoop = [];
}
